import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import getCacheParams from '../../../modules/getCacheParams';

import DonutChart from '../../Charts/DonutChart';
import LineChart from '../../Charts/LineChart';
import REQUEST from '../../../modules/REQUEST';
import BarChart from '../../Charts/BarChart';
import TreeMap from '../../Charts/TreeMap';
import { Context } from '../../../Context';
import './EvoPagamentos.css'

const newChart = (name) => ({ title: name, categories: [], series: [] })

let interval

export default () => {

    const { setLoading } = useContext(Context)

    const [data, setData] = useState([])
    const [charts, setCharts] = useState({})

    const registrosRef = useRef()
    const registroRef = useRef()

    useEffect(() => {
        // http://localhost:8084/evo_pagamentos?data_inicio=01.01.2023&data_fim=31.12.2023&data_inicio_p2=01.01.2023&data_fim_p2=31.12.2023&cliente=10&cr=18&tipoConsulta=3
        REQUEST.post('/rel/evo_pagamentos', getCacheParams())
            .then(resp => resp.data.filter(row => row.tipo_registro && row.tipo_registro !== 'P'))
            .then(setData)
            .then(() => setLoading(false))
            .catch(console.log)
    }, [])

    useEffect(() => {
        data.length && formatCharts()
    }, [data])

    const formatCharts = useCallback(() => {
        const newCharts = { totais: newChart('Totais por mês'), registros: newChart(''), registro: newChart(''), despesas: newChart('Total geral') }
        data.forEach((obj, index) => {
            if (!index) {
                Object.keys(obj).forEach((key) => {
                    if (key.includes('saldo') && !key.includes('total')) {
                        let newCategorie = key.split('_')
                        newCategorie = newCategorie[1] + ' ' + newCategorie[2]
                        newCharts.totais.categories.push(newCategorie)
                    }
                })
            }
            if (obj.tipo_registro === 'T') {
                const newSerie = { name: obj.nome.slice(6), data: [], type: 'line' }
                Object.keys(obj).forEach((key) => {
                    if (key.includes('saldo') && !key.includes('total')) {
                        newSerie.data.push(Math.round(obj[key] * 100) / 100)
                    }
                    else if (key.includes('total')) {
                        if(!newCharts.despesas.series.length){
                            newCharts.despesas.series.push({data: []})
                        }
                        newCharts.despesas.series[0].data.push({ x: obj.nome.trim().slice(6), y: (Math.round(obj[key] * 100) / 100) })
                    }
                })
                newCharts.totais.series.push(newSerie)
            }
            else if (obj.tipo_registro === 'R' && (!newCharts.registros?.selected || (newCharts.registros?.selected?.length && newCharts.registros.selected.includes(obj.nome_subnivel1)))) {
                if (!newCharts.registros.selected) {
                    // Primeira montagem de REGISTROS
                    newCharts.registros.selected = [obj.nome_subnivel1]
                    newCharts.registros.title = 'Registros do total ' + obj.nome_subnivel1.trim().toLowerCase() + ' (meses somados)'
                    newCharts.registros.series.push({ data: [] })
                    // Montando REGISTRO (não REGISTROS)
                    newCharts.registro.title = 'Detalhes dos registros de ' + obj.nome.trim().toLowerCase()
                    newCharts.registro.labels = []
                    Object.keys(obj).map(key => {
                        if(obj[key] && key.includes('saldo') && !key.includes('total')){
                            // Montando labels de REGISTRO
                            const newCategorie = key.split('_')
                            newCharts.registro.labels.push(newCategorie[1] + ' ' + newCategorie[2])
                            // Montando series de REGISTRO
                            newCharts.registro.series.push(obj[key])
                        }
                    })
                }
                // Montando REGISTROS
                newCharts.registros.categories.push(obj.nome.trim())
                newCharts.registros.series[0].data.push(Math.round(obj.saldo_total * 100) / 100)
            }
        })
        // console.log(newCharts)
        setCharts(newCharts)
    }, [data])

    const handleSelectDespesa = useCallback(async (subnivel, e) => {    
        const newRegistros = charts.registros
        const month = charts.registros.title.includes('meses somados') ? null : charts.registros.title.split('(')[1].slice(0, -1)
        const months = charts.totais.categories
        if(e.shiftKey){
            const currentCategories = charts.registros.categories
            const currentSeries = charts.registros.series[0].data
            const subniveis = charts.registros.selected
            const exclude = subniveis.includes(subnivel)
            const newCategories = []
            const newSeries = []
            if(exclude){
                subniveis.splice(subniveis.indexOf(subnivel), 1)
                data.forEach(obj => {
                    if(subniveis.includes(obj.nome_subnivel1)){
                        newCategories.push(obj.nome.trim())
                        if(month){
                            newSeries.push(Math.round(obj['saldo_' + month.replace(' ', '_')] * 100) / 100)
                        }
                        else {
                            newSeries.push(Math.round(months.reduce((acc, month) => acc + obj['saldo_' + month.replace(' ', '_')], 0) * 100) / 100)
                        }
                    }
                })
                window.scroll({ behavior: 'smooth', left: 0, top: registrosRef.current.offsetTop - 50 })
                newRegistros.series[0].data = newSeries
                newRegistros.categories = newCategories
                newRegistros.title = 'Registro do total ' + subniveis.reduce((acc, value, index) => acc + (index ? (index === subniveis.length - 1 ? ', ' : ' e ') : '') + value.toLowerCase(), '') + ' (' + (month || 'meses somados') + ')'
                newRegistros.selected = subniveis
            }
            else {
                data.forEach(obj => {
                    if(obj.nome_subnivel1 === subnivel){
                        newCategories.push(obj.nome.trim())
                        if(month){
                            newSeries.push(Math.round(obj['saldo_' + month.replace(' ', '_')] * 100) / 100)
                        }
                        else {
                            newSeries.push(Math.round(months.reduce((acc, month) => acc + obj['saldo_' + month.replace(' ', '_')], 0) * 100) / 100)
                        }
                    }
                })
                if(currentSeries.length + newSeries.length <= 15){
                    window.scroll({ behavior: 'smooth', left: 0, top: registrosRef.current.offsetTop - 50 })
                    newRegistros.series[0].data = [ ...currentSeries, ...newSeries ]
                    newRegistros.categories = [  ...currentCategories, ...newCategories ]
                    newRegistros.title = 'Registro do total ' + [...subniveis, subnivel].reduce((acc, value, index) => acc + (index ? (index === subniveis.length - 1 ? ', ' : ' e ') : '') + value.toLowerCase(), '') + ' (' + (month || 'meses somados') + ')'
                    newRegistros.selected = [ ...subniveis, subnivel ]
                }
            }
        }
        else {
            window.scroll({ behavior: 'smooth', left: 0, top: registrosRef.current.offsetTop - 50 })
            newRegistros.categories = []
            newRegistros.selected = [subnivel]
            newRegistros.series = [{ data: [] }]
            newRegistros.title = 'Registros do total ' + subnivel.trim().toLowerCase() + ' (' + (month || 'meses somados') +')'
            data.forEach(obj => {
                if(obj.tipo_registro === 'R' && obj.nome_subnivel1.trim() === subnivel){
                    newRegistros.categories.push(obj.nome.trim())
                    if(month){
                        newRegistros.series[0].data.push(obj['saldo_' + month.replace(' ', '_')])
                    }
                    else {
                        newRegistros.series[0].data.push(months.reduce((acc, value) => acc + obj['saldo_' + value.replace(' ', '_')], 0))
                    }
                }
            })
        }
        setCharts({ ...charts, registros: { ...charts.registros, ...newRegistros } })
    }, [charts])

    const handleDespesaClick = useCallback((event, props, config) => {
        if(interval){
            clearTimeout(interval)
            interval = null
            const newData = charts.despesas.series[0].data
            newData.splice(config.dataPointIndex, 1)
            setCharts({ ...charts, despesas: { ...charts.despesas, series: [{ data: newData }] } })
        }
        else {
            interval = setTimeout(() => {
                handleSelectDespesa(charts.despesas.series[0].data[config.dataPointIndex].x, event)
                clearTimeout(interval)
                interval = null
            }, 200)
        }
    }, [charts])

    const handleSelectMonth = useCallback((event, props, config) => {
        const label = charts.totais.categories[config.dataPointIndex]
        const month = 'saldo_' + label.replace(' ', '_')
        if (interval) {
            clearInterval(interval)
            let newCharts = {}
            newCharts.totais = {
                title: charts.totais.title,
                categories: charts.totais.categories.filter((value, index) => index !== config.dataPointIndex),
                series: charts.totais.series.map(serie => ({ ...serie, data: serie.data.filter((value, index) => index !== config.dataPointIndex) }))
            }
            newCharts.despesas = {
                title: charts.despesas.title,
                categories: [],
                series: [{ data: data.reduce((acc, obj) => obj.tipo_registro === 'T' ? [ ...acc, { x: obj.nome.trim().slice(6), y: Object.keys(obj).reduce((acc1, key) => newCharts.totais.categories.includes(key.slice(6).replace('_', ' ')) ? acc1 + obj[key] : acc1, 0) } ] : acc, []) }] 
            }
            const registro = data.find(obj => obj.tipo_registro === 'R' && charts.registro.title.includes(obj.nome.trim().toLowerCase()))
            const newSeriesReg = Object.keys(registro).reduce((acc, key) => registro[key] && newCharts.totais.categories.includes(key.slice(6).replace('_', ' ')) ? [ ...acc, (Math.round(registro[key] * 100) / 100) ]  : acc, [])
            newCharts.registro = {
                title: charts.registro.title,
                labels: charts.registro.labels.filter(regLabel => regLabel !== label),
                series: newSeriesReg
            }
            if (charts.registros.title.includes('meses')) {
                const newData = []
                charts.registros.categories.forEach(categorie => {
                    const registro = data.find(obj => obj.nome.trim() === categorie)
                    newData.push(Object.keys(registro).reduce((acc, key) => (newCharts.totais.categories.includes(key.slice(6).replace('_', ' '))) ? (acc + (Math.round(registro[key] * 100) / 100)) : acc, 0))
                })
                newCharts.registros = {
                    title: charts.registros.title,
                    series: [{ data: newData }],
                    categories: charts.registros.categories,
                    selected: charts.registros.selected
                }
            }
            else if (charts.registros.title.includes(label)) {
                newCharts.registros = {
                    title: 'Registros do total ' + charts.registros.selected.reduce((acc, value, index) => acc + (!index ? value : index < charts.registros.selected.length - 1 ? ', ' + value : ' e ' + value), '').toLowerCase() + ' (meses somados)',
                    categories: charts.registros.categories,
                    series: [{
                        data: data.reduce((acc, obj) => obj.tipo_registro === 'R' && charts.registros.selected.includes(obj.nome_subnivel1) ? [ ...acc, Object.keys(obj).reduce((acc1, key) => newCharts.totais.categories.includes(key.slice(6).replace('_', ' ')) ? acc1 + (Math.round(obj[key] * 100) / 100) : acc1, 0) ] : acc, [])
                    }],
                    selected: charts.registros.selected
                }
            }
            setCharts({ ...charts, ...newCharts })
            interval = undefined
        }
        else {
            interval = setTimeout(() => {
                window.scroll({ behavior: 'smooth', left: 0, top: registrosRef.current.offsetTop - 50 })
                if (String(charts.registros.title).includes(charts.totais.categories[config.dataPointIndex].toLowerCase())) {
                    const registros = {
                        title: 'Registros do total ' + charts.registros.selected.reduce((acc, value, index) => acc + (!index ? value : index < charts.registros.selected.length - 1 ? ', ' + value : ' e ' + value), '').toLowerCase() + ' (meses somados)',
                        series: [{
                            data: data.reduce((acc, obj) => obj.tipo_registro === 'R' && charts.registros.selected.includes(obj.nome_subnivel1.trim()) ? [ ...acc, Object.keys(obj).reduce((acc1, key) => charts.totais.categories.includes(key.slice(6).replace('_', ' ')) ? acc1 + (Math.round(obj[key] * 100) / 100) : acc1, 0) ] : acc, [])
                        }],
                        categories: charts.registros.categories,
                        selected: charts.registros.selected
                    }
                    setCharts({ ...charts, registros })
                }
                else {
                    const registros = { title: 'Registros do total ' + charts.registros.selected.reduce((acc, value, index) => acc + (!index ? value : index < charts.registros.selected.length - 1 ? ', ' + value : ' e ' + value), '').toLowerCase() + ' (' + charts.totais.categories[config.dataPointIndex] + ')', categories: charts.registros.categories, series: [{ data: [] }], selected: charts.registros.selected }
                    data.forEach(obj => {
                        if (obj.tipo_registro === 'R' && charts.registros.selected.includes(obj.nome_subnivel1)) {
                            registros.series[0].data.push(obj[month])
                        }
                    })
                    setCharts({ ...charts, registros })
                }
                interval = undefined
            }, 200);
        }
    }, [charts, data])

    const handleSelectRegistro = useCallback((event, props, config) => {
        window.scroll({ behavior: 'smooth', left: 0, top: registroRef.current.offsetTop - 50 })
        const registro = data.find(obj => obj.nome.trim() === charts.registros.categories[config.dataPointIndex])
        const newSeries = []
        const newLabels = []
        Object.keys(registro).forEach(key => {
            if(registro[key] && charts.totais.categories.includes(key.slice(6).replace('_', ' '))){
                const newLabel = key.split('_')
                newLabels.push(newLabel[1] + ' ' + newLabel[2])
                newSeries.push(Math.round(registro[key] * 100) / 100)
            }
        })
        setCharts({ ...charts, registro: { series: newSeries, labels: newLabels, title: ('Detalhes dos registros de ' + registro.nome.trim().toLowerCase()) } })
    }, [charts])

    const resetDespesas = useCallback(() => {
        const newData = []
        data.forEach(obj => {
            if(obj.tipo_registro === 'T') {
                newData.push({ x: obj.nome.trim().slice(6), y: (Math.round(obj.saldo_total * 100) / 100) })
            }
        })
        setCharts({ ...charts, despesas: { ...charts.despesas, series: [{ data: newData }] } })
    }, [charts, data])

    const customIconsTotais = [{
        icon: '<div class="apexcharts-reset-icon" title="Resetar Alterações"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg></div>',
        click: formatCharts,
        index: 3,
        title: 'Restaurar',
        class: 'me-2'
    }]

    const customIconsDespesas = [{
        icon: '<div class="apexcharts-reset-icon" title="Resetar Alterações"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg></div>',
        click: resetDespesas,
        index: -1,
        title: 'Restaurar',
        class: 'me-2'
    }]

    const DespesasOptions = useCallback(() => {
        return (
            charts.totais?.series &&
            charts.totais.series.map(serie => (
                <button className={'select-registro' + (charts.registros?.selected?.length && charts.registros.selected.includes(serie.name) ? ' selected' : '')} onClick={(e) => handleSelectDespesa(serie.name, e)} >{serie.name}</button>
            ))
        )
    }, [charts?.registros?.selected, charts?.totais?.categories, charts?.totais?.series, handleSelectDespesa])

    return (
        <div className="d-flex flex-wrap py-2">
            <div className="graph-cart px-3 py-2">
                <div className='shadow h-100 graph-cart-content'>
                    <LineChart categories={charts.totais?.categories} series={charts.totais?.series} title={charts.totais?.title} width='100%' height='100%' events={{ dataPointSelection: handleSelectMonth }} customIcons={customIconsTotais} />
                </div>
            </div>
            <div className="graph-cart px-3 py-2">
                <div className='shadow h-100 graph-cart-content'>
                    <TreeMap customIcons={customIconsDespesas} series={charts.despesas?.series} title={charts.despesas?.title} width='100%' height='100%' events={{ dataPointSelection: handleDespesaClick }} />
                </div>
            </div>
            <div className="graph-cart px-3 py-2 w-100" ref={registrosRef}>
                <div className='shadow h-100 graph-cart-content d-flex w-100'>
                    <div style={{ width: 'calc(100% - 200px)' }}>
                        <BarChart categories={charts.registros?.categories} series={charts.registros?.series} title={charts.registros?.title} width='100%' height='100%' events={{ dataPointSelection: handleSelectRegistro }} />
                    </div>
                    <div className='select-registros-menu' style={{ width: '200px' }}>
                        <p className='mx-2 h5'>Selecione um tipo de registro:</p>
                        <DespesasOptions />
                    </div>
                </div>
            </div>
            <div className="graph-cart px-3 py-2" ref={registroRef}>
                <div className='shadow h-100 graph-cart-content'>
                    <DonutChart series={charts.registro?.series} labels={charts.registro?.labels} title={charts.registro?.title} width='100%' height='100%' />
                </div>
            </div>
        </div>
    ) 
}